import { EUROPE_REGIONS } from 'constants/config/region'
import moment from 'moment'

// Strictly no more than 59 elapsed minutes; this is shorter than the API's lookback.
export const SOCIAL_PROOF_MAX_AGE_MS = 59 * 60 * 1000

export function isSocialProofPurchaseFresh(purchasedAt: string, now: number): boolean {
  const purchaseTime = moment(purchasedAt, moment.ISO_8601, true)
  // Keep millisecond precision so purchases just over 59 minutes are rejected.
  const ageMs = moment(now).diff(purchaseTime, 'milliseconds')
  return purchaseTime.isValid() && ageMs >= 0 && ageMs <= SOCIAL_PROOF_MAX_AGE_MS
}

function getPurchasePriority(purchase: App.OfferRecentPurchase, websiteRegion: string): number {
  const country = purchase.country.trim().toUpperCase()
  if (EUROPE_REGIONS.has(websiteRegion) && EUROPE_REGIONS.has(country) && country !== websiteRegion) return 2
  return purchase.isLuxPlusPurchase === true ? 1 : 0
}

/** Another European storefront outranks member status; newest wins within each priority. */
export function selectSocialProofPurchase(
  purchases: ReadonlyArray<App.OfferRecentPurchase> | undefined,
  websiteRegion: string,
  now: number,
): App.OfferRecentPurchase | undefined {
  const region = websiteRegion.trim().toUpperCase()
  let selected: App.OfferRecentPurchase | undefined
  let selectedPriority = -1

  for (const purchase of purchases ?? []) {
    if (!purchase.country.trim() || !isSocialProofPurchaseFresh(purchase.purchasedAt, now)) continue
    const priority = getPurchasePriority(purchase, region)
    const isNewerPurchase = selected && moment(purchase.purchasedAt).isAfter(selected.purchasedAt)
    if (priority > selectedPriority || (priority === selectedPriority && isNewerPurchase)) {
      selected = purchase
      selectedPriority = priority
    }
  }

  return selected
}
